import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';


export function useScrollToTop(active = false) {
    const location = useLocation();
    const navigationType = useNavigationType();
    const isNewPageLoad = navigationType === 'PUSH';

    useEffect(() => {
        if (isNewPageLoad) {
            console.info("[useScrollToTop] scrolling to top...");
            window.scrollTo(0, 0);
        }
    }, [isNewPageLoad, location.pathname]);
}